module.exports = __webpack_public_path__ + "img/close.1eeed421.svg";